module.exports = __webpack_public_path__ + "img/ball_6.b18868fa.png";